import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Entry point for the modern React 19 admin settings app.
 *
 * Exposes mount/unmount on window so the Backbone builder can control lifecycle.
 * The builder passes the Backbone notifications controller into mount() so React
 * can show notifications through the existing app-wide system.
 *
 * React docs — createRoot: https://react.dev/reference/react-dom/client/createRoot
 */
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { useSettingsStore } from './store/settings-store';
let root = null;
let container = null;
function mount(notifications) {
    if (notifications) {
        useSettingsStore.getState().setNotifications(notifications);
    }
    const content = document.getElementById('content');
    if (!content) {
        return;
    }
    container = document.createElement('div');
    container.id = 'modern-root';
    content.appendChild(container);
    root = createRoot(container);
    root.render(_jsx(App, {}));
}
function unmount() {
    if (root) {
        root.unmount();
        root = null;
    }
    if (container) {
        container.remove();
        container = null;
    }
}
;
window.ModernReactApp = { mount, unmount };
